import { render, staticRenderFns } from "./SalePoint.vue?vue&type=template&id=61166155&scoped=true&lang=pug&"
import script from "./SalePoint.vue?vue&type=script&lang=js&"
export * from "./SalePoint.vue?vue&type=script&lang=js&"
import style0 from "./SalePoint.vue?vue&type=style&index=0&id=61166155&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61166155",
  null
  
)

component.options.__file = "SalePoint.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VFlex,
  VLayout,
  VProgressCircular,
})
